/* eslint-disable no-use-before-define */
/* eslint-disable no-lonely-if */
const { placeholders } = require("../../../locales/placeholdersData");

const searchForm = document.getElementById("searchForm");
const searchInput = document.getElementById("searchInput");
const searchButton = document.getElementById("searchButton");
const searchErrorMessage = document.getElementById("searchErrorMessage");
const searchPlaceholder = document.getElementById("searchPlaceholder");
const errorIconContainer = document.getElementById("errorIconContainer");
const containerFormSearch = document.querySelector(".container-form-search");

let currentPlaceholderIndex = 0;
let placeholderInterval;
let typingTimeout;

const typingSpeed = 100;
const delayBeforeNextPlaceholder = 2000;

const getCurrentLanguage = () => {
  const langInput = document.querySelector('input[name="lang"]');
  if (langInput && langInput.value) {
    return langInput.value;
  }
  return "en";
};

const typePlaceholder = (text, element, callback) => {
  let i = 0;
  element.textContent = "";

  if (typingTimeout) {
    clearTimeout(typingTimeout);
  }

  const type = () => {
    if (i < text.length) {
      element.textContent += text.charAt(i);
      i++;
      typingTimeout = setTimeout(type, typingSpeed);
    } else if (callback) {
      callback();
    }
  };
  type();
};

const rotatePlaceholders = () => {
  if (typeof placeholders === "undefined") {
    return;
  }

  if (document.hidden) {
    return;
  }

  const lang = getCurrentLanguage();
  const currentLanguagePlaceholders = placeholders[lang] || placeholders["en"];

  if (searchInput.value.trim() !== "" || searchInput.classList.contains("error-state")) {
    if (searchPlaceholder) {
      searchPlaceholder.style.opacity = "0";
      clearInterval(placeholderInterval);
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      searchPlaceholder.textContent = "";
    }
    return;
  }

  if (searchPlaceholder) {
    searchPlaceholder.classList.remove("error-placeholder");
    searchPlaceholder.style.opacity = "1";
    typePlaceholder(currentLanguagePlaceholders[currentPlaceholderIndex], searchPlaceholder, () => {
      currentPlaceholderIndex = (currentPlaceholderIndex + 1) % currentLanguagePlaceholders.length;
    });
  }
};

const startPlaceholderRotation = () => {
  if (placeholderInterval) {
    clearInterval(placeholderInterval);
  }
  if (typingTimeout) {
    clearTimeout(typingTimeout);
  }

  if (searchInput.classList.contains("error-state")) {
    if (searchPlaceholder) {
      searchPlaceholder.classList.add("error-placeholder");
      searchPlaceholder.textContent = "";
      searchPlaceholder.style.opacity = "1";
    }
    return;
  }

  if (searchInput.value.trim() !== "") {
    if (searchPlaceholder) {
      searchPlaceholder.style.opacity = "0";
      searchPlaceholder.textContent = "";
    }
    return;
  }

  rotatePlaceholders();
  placeholderInterval =
    setInterval(
      rotatePlaceholders,
      delayBeforeNextPlaceholder + (placeholders[getCurrentLanguage()]?.[currentPlaceholderIndex]?.length || 0) * typingSpeed
    );
};

const validateSearchInput = () => {
  const query = searchInput.value.trim();
  return query.length >= 2;
};

const handleVisibilityChange = () => {
  if (document.hidden) {
    if (placeholderInterval) {
      clearInterval(placeholderInterval);
    }
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
  } else {
    if (searchInput.classList.contains("error-state")) {
      showErrorState();
    } else if (searchInput.value.trim() === "") {
      currentPlaceholderIndex = 0;
      startPlaceholderRotation();
    } else {
      if (searchPlaceholder) {
        searchPlaceholder.style.opacity = "0";
        searchPlaceholder.textContent = "";
      }
    }
  }
};

const showErrorState = () => {
  searchInput.classList.add("error-state");
  if (containerFormSearch) {
    containerFormSearch.classList.add("error-state");
  }

  if (containerFormSearch) {
    containerFormSearch.style.borderColor = "#D9534C";
  }
  if (errorIconContainer) {
    errorIconContainer.style.display = "flex";
  }
  if (searchPlaceholder) {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    clearInterval(placeholderInterval);

    searchPlaceholder.textContent = "";
    searchPlaceholder.classList.add("error-placeholder");
    searchPlaceholder.textContent = "";
    searchPlaceholder.style.opacity = "1";
  }
  if (searchErrorMessage) {
    searchErrorMessage.style.display = "block";
    searchErrorMessage.classList.add("show");
  }
};

const hideErrorState = () => {
  searchInput.classList.remove("error-state");
  if (containerFormSearch) {
    containerFormSearch.classList.remove("error-state");
  }

  if (containerFormSearch) {
    containerFormSearch.style.borderColor = "var(--border-container-sidebar)";
  }
  if (errorIconContainer) {
    errorIconContainer.style.display = "none";
  }
  if (searchPlaceholder) {
    searchPlaceholder.classList.remove("error-placeholder");
    searchPlaceholder.textContent = "";
  }
  if (searchErrorMessage) {
    searchErrorMessage.classList.remove("show");
    searchErrorMessage.style.display = "none";
  }

  if (searchInput.value.trim() === "") {
    startPlaceholderRotation();
  }
};

if (searchForm && searchInput) {
  searchForm.addEventListener("click", () => {
    searchInput.focus();
  });
}

document.addEventListener("visibilitychange", handleVisibilityChange);

if (searchButton) {
  searchButton.disabled = false;
}

if (searchInput && searchErrorMessage) {
  searchInput.addEventListener("input", () => {
    if (searchInput.classList.contains("error-state")) {
      hideErrorState();
    }

    if (searchInput.value.trim() !== "") {
      if (searchPlaceholder) {
        searchPlaceholder.style.opacity = "0";
        clearInterval(placeholderInterval);
        if (typingTimeout) {
          clearTimeout(typingTimeout);
        }
        searchPlaceholder.textContent = "";
      }
    } else {
      startPlaceholderRotation();
    }
  });

  searchInput.addEventListener("focus", () => {
    if (searchPlaceholder && !searchInput.classList.contains("error-state")) {
      searchPlaceholder.style.opacity = "0";
      clearInterval(placeholderInterval);
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      searchPlaceholder.textContent = "";
    }
  });

  searchInput.addEventListener("blur", () => {
    if (searchInput.value.trim() === "" && !searchInput.classList.contains("error-state")) {
      startPlaceholderRotation();
    }
  });

} else {
  console.error("Failed to attach 'input' event handler. Elements are missing.");
}

if (searchForm && searchInput && searchErrorMessage) {
  searchForm.addEventListener("submit", (event) => {
    const isValid = validateSearchInput();

    if (!isValid) {
      event.preventDefault();
      showErrorState();
      searchInput.focus();
    } else {
      hideErrorState();
    }
  });
} else {
  console.error("Failed to attach the 'submit' handler. Elements are missing.");
}

if (searchErrorMessage) {
  searchErrorMessage.style.display = "none";
}

if (searchInput && searchPlaceholder) {
  if (searchInput.value.trim() === "") {
    startPlaceholderRotation();
  } else {
    searchPlaceholder.style.opacity = "0";
    searchPlaceholder.textContent = "";
  }
}
